import React from "react";
import "./Consultation.css";
// Removed useState, DropDown, emailjs imports as they are no longer needed

function Consultation() {
  // Removed state variables (selected, formData) and handlers (handleChange, handleSubmit)

  // Get this embed URL from your Google Form: Go to your form -> Send -> <> Embed HTML -> Copy the src attribute value
  const googleFormEmbedUrl = "https://forms.gle/TN2mNV9krnaQBEGYA"; // <-- *** REPLACE THIS WITH YOUR ACTUAL GOOGLE FORM EMBED URL ***

  // You might need to adjust the height based on your form's length
  const iframeHeight = "800"; // Adjust this value as needed

  return (
    // Using className instead of class for React JSX
    <div className="consultation_outer" id="consultation">
      <div className="container">
        <div className="consultation_inner">
          {/* Left side text content remains the same */}
          <div className="consultation_text">
            <div className="consultation_heading">
              Get free personal consultation.
            </div>
            <div className="consultation_contact">
              <div className="consultation_contact_heading">Contact</div>
              <div className="consultation_contact_email">
                <a href="mailto:finaltaxglobal@gmail.com">
                  finaltaxglobal@gmail.com
                </a>
                <br />
                <a href="tel:+919461008161">+91 9461008161</a>
                <br />
                <a href="tel:+919462192353">+91 9462192353</a>
              </div>
              
            </div>
            <div className="consultation_hours">
              <div className="consultation_hours_heading">Consultation Hours</div>
              <div className="consultation_hours_timings">10 AM to 9 PM</div>
            </div>
            <div className="consultation_location">
              <div className="consultation_location_heading">Location</div>
              <div className="consultation_location_address">Pune, India</div>
              <div className="consultation_location_address">Bangalore, India</div>
              <div className="consultation_location_address">North Carolina, US</div>
            </div>
          </div>

          {/* Right side form area now contains the Google Form iframe */}
          <div className="consultation_form">
            {/* Replace the original form structure with the iframe */}
            <iframe
              src={googleFormEmbedUrl}
              width="100%" // Use 100% to fill the container width
              height={iframeHeight}
              frameBorder="0" // Optional: removes the default iframe border
              marginHeight="0"
              marginWidth="0"
              title="Consultation Request Form" // Added title for accessibility
              style={{ border: 'none', minHeight: '700px' }} // Ensure no border and set a minimum height
            >
              Loading…
            </iframe>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Consultation;
